enum StatusType {
  ACTIVE = "ACTIVE",
  PENDING = "PENDING",
  PENDING_REVIEW = "PENDING_REVIEW",
  INACTIVE = "INACTIVE",
  DECLINED = "DECLINED",
  CLOSED = "CLOSED",
  FROZEN = "FROZEN",
  DEACTIVATED = "DEACTIVATED",
}

export default StatusType;
